module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account--wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card ui-card form--account"
  }, [(_vm.idToEdit != null) ? [_c('div', {
    staticClass: "kp-panel-header",
    class: {
      'kp-panel-header--parked': _vm.model.kpPark === true,
      'kp-panel-header--linked': _vm.model.kpPark !== true && _vm.model.kpAdId != null && ('' + _vm.model.kpAdId).trim().length > 0,
      'kp-panel-header--unlinked': _vm.model.kpPark !== true && (_vm.model.kpAdId == null || ('' + _vm.model.kpAdId).trim().length === 0)
    },
    on: {
      "click": _vm.toggleKpPanel
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "kp-panel-arrow"
  }, [(_vm.showKpPanel) ? _c('span', [_vm._v("▲")]) : _c('span', [_vm._v("▼")])])]), _vm._v(" "), (_vm.showKpPanel) ? _c('div', [_c('div', {
    staticClass: "article-gallery"
  }, [_c('div', {
    staticClass: "gallery-main",
    on: {
      "click": _vm.onMainImageClick
    }
  }, [(_vm.articleImages.length > 0) ? [_c('img', {
    staticClass: "gallery-main-img",
    attrs: {
      "src": _vm.selectedImageUrl,
      "alt": _vm.locale.t('label_primary'),
      "loading": "lazy"
    }
  }), _vm._v(" "), (_vm.selectedIsPrimary) ? _c('div', {
    staticClass: "gallery-main-badge"
  }, [_vm._v("\n                      " + _vm._s(_vm.locale.t('label_primary')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.selectedImage && !_vm.selectedIsPrimary) ? _c('button', {
    staticClass: "gallery-main-action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setPrimaryImage(_vm.selectedImage, false)
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.locale.t('label_set_as_primary')) + "\n                    ")]) : _vm._e()] : [_c('div', {
    staticClass: "gallery-empty"
  }, [_c('div', {
    staticClass: "gallery-empty-icon"
  }, [_vm._v("📷")]), _vm._v(" "), _c('div', {
    staticClass: "gallery-empty-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.locale.t('label_add_photos')) + "\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "gallery-empty-sub"
  }, [_vm._v("\n                        " + _vm._s(_vm.locale.t('label_add_photos_hint')) + "\n                      ")])])], _vm._v(" "), (_vm.isAnyUploading) ? _c('div', {
    staticClass: "gallery-main-uploading"
  }, [_c('div', {
    staticClass: "upload-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-text"
  }, [_vm._v(_vm._s(_vm.locale.t('label_uploading')))])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "gallery-thumbs"
  }, [_c('button', {
    staticClass: "thumb thumb-add",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openImagePicker
    }
  }, [_c('div', {
    staticClass: "thumb-add-plus"
  }, [_vm._v("+")]), _vm._v(" "), _c('div', {
    staticClass: "thumb-add-text"
  }, [_vm._v(_vm._s(_vm.locale.t('label_add')))])]), _vm._v(" "), _vm._l((_vm.articleImages), function(img) {
    return _c('div', {
      key: img.localId,
      staticClass: "thumb-item"
    }, [_c('div', {
      staticClass: "thumb",
      class: {
        'thumb-primary': img.isPrimary
      },
      on: {
        "click": function($event) {
          return _vm.selectImage(img);
        }
      }
    }, [(!img.uploading) ? _c('img', {
      attrs: {
        "src": img.url,
        "alt": _vm.locale.t('label_picture'),
        "loading": "lazy"
      }
    }) : _vm._e(), _vm._v(" "), (img.isPrimary) ? _c('div', {
      staticClass: "thumb-primary-label"
    }, [_vm._v("\n                        " + _vm._s(_vm.locale.t('label_main_image_thumb')) + "\n                      ")]) : _c('div', {
      staticClass: "thumb-uploading"
    }, [_vm._m(1, true), _vm._v(" "), (img.progress != null) ? _c('div', {
      staticClass: "thumb-progress"
    }, [_vm._v(_vm._s(img.progress) + "%")]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "thumb-remove",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeImage(img)
        }
      }
    }, [_vm._v("\n                        ✕\n                      ")])]), _vm._v(" "), (_vm.canReorderImages) ? _c('div', {
      staticClass: "thumb-order-actions"
    }, [_c('button', {
      staticClass: "thumb-order-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveImageLeft(img)
        }
      }
    }, [_vm._v("\n                        ←\n                      ")]), _vm._v(" "), _c('button', {
      staticClass: "thumb-order-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveImageRight(img)
        }
      }
    }, [_vm._v("\n                        →\n                      ")])]) : _vm._e()])
  })], 2), _vm._v(" "), (_vm.articleImages.length > 0) ? _c('div', {
    staticClass: "gallery-order-row"
  }, [(_vm.articleImages.length > 1) ? _c('button', {
    staticClass: "gallery-order-save-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.canReorderImages || !_vm.imageOrderDirty || _vm.imageOrderSaving
    },
    on: {
      "click": _vm.saveImagesOrder
    }
  }, [(_vm.imageOrderSaving) ? _c('span', [_vm._v(_vm._s(_vm.locale.t('label_uploading')))]) : _c('span', [_vm._v(_vm._s(_vm.locale.t('label_save_image_order')))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "gallery-order-save-btn gallery-order-save-btn--zip",
    attrs: {
      "type": "button",
      "disabled": _vm.downloadImagesZipLoading || _vm.isAnyUploading
    },
    on: {
      "click": _vm.downloadAllImagesZip
    }
  }, [(_vm.downloadImagesZipLoading) ? _c('span', [_vm._v(_vm._s(_vm.locale.t('label_uploading')))]) : _c('span', [_vm._v(_vm._s(_vm.locale.t('label_download_all_images_zip')))])])]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "imagesInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*",
      "multiple": ""
    },
    on: {
      "change": _vm.onImagesSelected
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "kp-section"
  }, [_c('div', {
    staticClass: "kp-section-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_section_title')))]), _vm._v(" "), _c('div', {
    staticClass: "row kp-row"
  }, [_c('div', {
    staticClass: "col-md-6 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_category')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpCategoryId),
      expression: "model.kpCategoryId"
    }],
    staticClass: "kp-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "kpCategoryId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("--")]), _vm._v(" "), _vm._l((_vm.kpCategories), function(c) {
    return _c('option', {
      key: c.id,
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2), _vm._v(" "), (_vm.kpLoadingCategories) ? _c('div', {
    staticClass: "kp-hint"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_loading_categories')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_group')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpGroupId),
      expression: "model.kpGroupId"
    }],
    staticClass: "kp-control",
    attrs: {
      "disabled": !_vm.model.kpCategoryId
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "kpGroupId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("--")]), _vm._v(" "), _vm._l((_vm.kpGroups), function(g) {
    return _c('option', {
      key: g.id,
      domProps: {
        "value": g.id
      }
    }, [_vm._v(_vm._s(g.name))])
  })], 2), _vm._v(" "), (_vm.kpLoadingGroups) ? _c('div', {
    staticClass: "kp-hint"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_loading_groups')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row kp-row"
  }, [_c('div', {
    staticClass: "col-md-6 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_type')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpType),
      expression: "model.kpType"
    }],
    staticClass: "kp-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "kpType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("--")]), _vm._v(" "), _vm._l((_vm.kpTypeOptions), function(o) {
    return _c('option', {
      key: o.value,
      domProps: {
        "value": o.value
      }
    }, [_vm._v(_vm._s(o.label))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_condition')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpCondition),
      expression: "model.kpCondition"
    }],
    staticClass: "kp-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "kpCondition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("--")]), _vm._v(" "), _vm._l((_vm.kpConditionOptions), function(o) {
    return _c('option', {
      key: o.value,
      domProps: {
        "value": o.value
      }
    }, [_vm._v(_vm._s(o.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row kp-row"
  }, [_c('div', {
    staticClass: "col-md-4 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_price')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpPrice),
      expression: "model.kpPrice"
    }],
    staticClass: "kp-control",
    domProps: {
      "value": (_vm.model.kpPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "kpPrice", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_currency')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpCurrency),
      expression: "model.kpCurrency"
    }],
    staticClass: "kp-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "kpCurrency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("--")]), _vm._v(" "), _vm._l((_vm.kpCurrencyOptions), function(o) {
    return _c('option', {
      key: o.value,
      domProps: {
        "value": o.value
      }
    }, [_vm._v(_vm._s(o.label))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_price_text')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpPriceText),
      expression: "model.kpPriceText"
    }],
    staticClass: "kp-control",
    attrs: {
      "placeholder": _vm.locale.t('label_kp_contact_placeholder')
    },
    domProps: {
      "value": (_vm.model.kpPriceText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "kpPriceText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row kp-row"
  }, [_c('div', {
    staticClass: "col-md-12 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_description_html')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-editor-toolbar"
  }, [_c('button', {
    staticClass: "kp-editor-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.applyKpInlineFormat('bold')
      }
    }
  }, [_c('strong', [_vm._v("B")]), _vm._v(" " + _vm._s(_vm.locale.t('label_kp_editor_bold')) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "kp-editor-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.applyKpInlineFormat('italic')
      }
    }
  }, [_c('em', [_vm._v("I")]), _vm._v(" " + _vm._s(_vm.locale.t('label_kp_editor_italic')) + "\n                      ")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpDescription),
      expression: "model.kpDescription"
    }],
    ref: "kpDescriptionEditor",
    staticClass: "kp-control kp-textarea",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.model.kpDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "kpDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row kp-row"
  }, [_c('div', {
    staticClass: "col-md-6 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_post_date')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-info-chip"
  }, [_vm._v(_vm._s(_vm.getKpPostDateDisplay()))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_ad_age')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-info-chip"
  }, [_vm._v(_vm._s(_vm.getKpAdAgeDaysDisplay()))])])]), _vm._v(" "), _c('div', {
    staticClass: "row kp-row"
  }, [_c('div', {
    staticClass: "col-md-12 kp-col"
  }, [_c('div', {
    staticClass: "kp-more-toggle",
    on: {
      "click": _vm.toggleKpMoreDetails
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.showKpMoreDetails ? _vm.locale.t('label_kp_less_details') : _vm.locale.t('label_kp_more_details')))]), _vm._v(" "), _c('span', {
    staticClass: "kp-more-toggle__arrow"
  }, [_vm._v(_vm._s(_vm.showKpMoreDetails ? '▲' : '▼'))])])])]), _vm._v(" "), (_vm.showKpMoreDetails) ? _c('div', [_c('div', {
    staticClass: "row kp-row"
  }, [_c('div', {
    staticClass: "col-md-6 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_group_suggest_text')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpGroupSuggestText),
      expression: "model.kpGroupSuggestText"
    }],
    staticClass: "kp-control",
    domProps: {
      "value": (_vm.model.kpGroupSuggestText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "kpGroupSuggestText", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_ad_id')))]), _vm._v(" "), (_vm.model.kpAdId) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpAdId),
      expression: "model.kpAdId"
    }],
    staticClass: "kp-control",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.model.kpAdId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "kpAdId", $event.target.value)
      }
    }
  }) : _c('div', {
    staticClass: "kp-share-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kpImportId),
      expression: "kpImportId"
    }],
    staticClass: "kp-control",
    attrs: {
      "placeholder": _vm.locale.t('label_kp_ad_id'),
      "disabled": _vm.kpImportLoading
    },
    domProps: {
      "value": (_vm.kpImportId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.kpImportId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "kp-share-copy",
    attrs: {
      "type": "button",
      "disabled": _vm.kpImportLoading
    },
    on: {
      "click": _vm.importKpAdFromManualId
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.kpImportLoading ? _vm.locale.t('label_kp_import_loading') : _vm.locale.t('label_kp_import')) + "\n                        ")]), _vm._v(" "), _c('button', {
    staticClass: "kp-share-copy kp-share-copy--secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.kpImportLoading
    },
    on: {
      "click": _vm.importKpAdIdOnlyFromManualId
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.kpImportLoading ? _vm.locale.t('label_kp_import_loading') : _vm.locale.t('label_kp_import_id_only')) + "\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row kp-row"
  }, [_c('div', {
    staticClass: "col-md-12 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_share_url')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-share-wrap"
  }, [_c('input', {
    staticClass: "kp-control",
    attrs: {
      "readonly": "",
      "placeholder": _vm.locale.t('label_kp_click_to_copy')
    },
    domProps: {
      "value": _vm.buildKpShareUrl()
    },
    on: {
      "click": _vm.copyKpShareUrl
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "kp-share-copy",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.copyKpShareUrl
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_copy')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row kp-row"
  }, [_c('div', {
    staticClass: "col-md-4 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_immediate_available')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpImmediateAvailable),
      expression: "model.kpImmediateAvailable"
    }],
    staticClass: "kp-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "kpImmediateAvailable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("--")]), _vm._v(" "), _vm._l((_vm.kpYesNoOptions), function(o) {
    return _c('option', {
      key: o.value,
      domProps: {
        "value": o.value
      }
    }, [_vm._v(_vm._s(o.label))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_exchange')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpExchange),
      expression: "model.kpExchange"
    }],
    staticClass: "kp-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "kpExchange", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("--")]), _vm._v(" "), _vm._l((_vm.kpYesNoOptions), function(o) {
    return _c('option', {
      key: o.value,
      domProps: {
        "value": o.value
      }
    }, [_vm._v(_vm._s(o.label))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_price_fixed')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpPriceFixed),
      expression: "model.kpPriceFixed"
    }],
    staticClass: "kp-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "kpPriceFixed", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("--")]), _vm._v(" "), _vm._l((_vm.kpYesNoOptions), function(o) {
    return _c('option', {
      key: o.value,
      domProps: {
        "value": o.value
      }
    }, [_vm._v(_vm._s(o.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row kp-row"
  }, [_c('div', {
    staticClass: "col-md-6 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_local_pickup')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpLocalPickup),
      expression: "model.kpLocalPickup"
    }],
    staticClass: "kp-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "kpLocalPickup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("--")]), _vm._v(" "), _vm._l((_vm.kpYesNoOptions), function(o) {
    return _c('option', {
      key: o.value,
      domProps: {
        "value": o.value
      }
    }, [_vm._v(_vm._s(o.label))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 kp-col"
  }, [_c('label', {
    staticClass: "kp-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_courier_delivery')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.kpCourierDelivery),
      expression: "model.kpCourierDelivery"
    }],
    staticClass: "kp-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "kpCourierDelivery", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("--")]), _vm._v(" "), _vm._l((_vm.kpYesNoOptions), function(o) {
    return _c('option', {
      key: o.value,
      domProps: {
        "value": o.value
      }
    }, [_vm._v(_vm._s(o.label))])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.idToEdit != null) ? _c('div', {
    staticClass: "row kp-row"
  }, [_c('div', {
    staticClass: "col-md-12 kp-col"
  }, [(_vm.kpActionLoading) ? _c('div', {
    staticClass: "kp-submit-loading"
  }, [_vm._m(2), _vm._v(" "), (_vm.kpActionType === 'publish') ? _c('span', [_vm._v(_vm._s(_vm.locale.t('label_kp_action_publish_loading')))]) : (_vm.kpActionType === 'update') ? _c('span', [_vm._v(_vm._s(_vm.locale.t('label_kp_action_update_loading')))]) : (_vm.kpActionType === 'park') ? _c('span', [_vm._v(_vm._s(_vm.locale.t('label_kp_action_park_loading')))]) : (_vm.kpActionType === 'unpark') ? _c('span', [_vm._v(_vm._s(_vm.locale.t('label_kp_action_unpark_loading')))]) : (_vm.kpActionType === 'unlink') ? _c('span', [_vm._v(_vm._s(_vm.locale.t('label_kp_action_unlink_loading')))]) : (_vm.kpActionType === 'delete') ? _c('span', [_vm._v(_vm._s(_vm.locale.t('label_kp_action_delete_loading')))]) : _c('span', [_vm._v(_vm._s(_vm.locale.t('label_kp_action_processing')))])]) : _c('div', {
    staticClass: "kp-action-row"
  }, [(!_vm.model.kpAdId) ? _c('button', {
    staticClass: "kp-submit-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.publishKpAd
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.locale.t('label_kp_publish')) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.model.kpAdId) ? _c('button', {
    staticClass: "kp-submit-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateKpAdAction
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.locale.t('label_kp_update')) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.model.kpAdId && _vm.model.kpPark !== true) ? _c('button', {
    staticClass: "kp-submit-btn kp-submit-btn--secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.parkKpAd
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.locale.t('label_kp_park')) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.model.kpAdId && _vm.model.kpPark === true) ? _c('button', {
    staticClass: "kp-submit-btn kp-submit-btn--secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.unparkKpAd
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.locale.t('label_kp_unpark')) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.model.kpAdId) ? _c('button', {
    staticClass: "kp-submit-btn kp-submit-btn--danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.unlinkKpAd
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.locale.t('label_kp_unlink')) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.model.kpAdId) ? _c('button', {
    staticClass: "kp-submit-btn kp-submit-btn--danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteKpAd
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.locale.t('label_kp_delete')) + "\n                      ")]) : _vm._e()])])]) : _vm._e()])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('H1', [_vm._v(_vm._s(_vm.title) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.addCategories()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" \n              " + _vm._s(_vm.locale.t('label_a_c_add')) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_name')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_a_name'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('label', {
    staticClass: "custom-file-upload",
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "for": "select"
    }
  }, [_c('i', {
    staticClass: "fas fa-cloud-upload-alt"
  }), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "id": "select",
      "accept": "image/*;capture=camera"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "scrollmenu",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "5px"
    }
  }, _vm._l((_vm.imeiLabels), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.onSelectImeiType(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClassImei(item)
    }, [_vm._v(_vm._s(_vm.isSelectedImei(item) ? '✔ ' : '') + _vm._s(item))])])]), _vm._v(" \n                          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.selectedImeiItem))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon",
    on: {
      "click": function($event) {
        _vm.showQrCodeScanner = !_vm.showQrCodeScanner
      }
    }
  }, [_vm._m(4)]), _vm._v(" "), ((_vm.imeiType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.code),
      expression: "model.code"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.selectedImeiItem,
      "name": "email",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.code) ? _vm._i(_vm.model.code, null) > -1 : (_vm.model.code)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.code,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "code", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "code", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "code", $$c)
        }
      }
    }
  }) : ((_vm.imeiType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.code),
      expression: "model.code"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.selectedImeiItem,
      "name": "email",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.model.code, null)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.model, "code", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.code),
      expression: "model.code"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.selectedImeiItem,
      "name": "email",
      "type": _vm.imeiType
    },
    domProps: {
      "value": (_vm.model.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "code", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.selectedImeiItem === _vm.locale.t('label_a_code') && _vm.model.code.length > 0 && (_vm.model.code.length !== 15 || !(/^\d+$/.test(this.model.code)))) ? _c('label', {
    staticStyle: {
      "color": "red",
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_imei_error')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollmenu",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "5px"
    }
  }, _vm._l((_vm.categories.slice(0, 10)), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          _vm.newSelectedCategory = item;
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClass(item)
    }, [_vm._v(_vm._s(_vm.isSelected(item) ? '✔ ' : '') + _vm._s(item))])])]), _vm._v(" \n                          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_category')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), (_vm.visibleCategory) ? _c('autocompleteObject', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "suggestions": _vm.categories,
      "placeholder": _vm.locale.t('label_a_category')
    },
    on: {
      "update:selectedModel": function($event) {
        _vm.newSelectedCategory = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.visibleCategory) ? _c('div', {
    staticClass: "input",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.deleteCategory
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.newSelectedCategory) + " "), _c('i', {
    staticClass: "ti-trash"
  })])]) : _vm._e()], 1)])])])]), _vm._v(" "), (!_vm.visibleCategory) ? _c('div', {
    staticClass: "scrollmenu",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "5px"
    }
  }, _vm._l((_vm.selectedSubCategories.slice(0, 10)), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          _vm.newSelectedSubCategory = item;
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClassSub(item)
    }, [_vm._v(_vm._s(_vm.isSelectedSub(item) ? '✔ ' : '') + _vm._s(item))])])]), _vm._v(" \n                          ")])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.visibleCategory) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_sub_category')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), (_vm.visibleSubCategory) ? _c('autocompleteObject', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "suggestions": _vm.selectedSubCategories,
      "placeholder": _vm.locale.t('label_a_sub_category')
    },
    on: {
      "update:selectedModel": function($event) {
        _vm.newSelectedSubCategory = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.visibleSubCategory) ? _c('div', {
    staticClass: "input",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.deleteSubCategory
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.newSelectedSubCategory) + " "), _c('i', {
    staticClass: "ti-trash"
  })])]) : _vm._e()], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.colorsByCategory.length > 0) ? _c('div', {
    staticClass: "scrollmenu",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "5px"
    }
  }, _vm._l((_vm.colorsByCategory), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          _vm.model.color = item;
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getColorClass(item)
    }, [_vm._v(_vm._s(_vm.isSelectedColor(item) ? '✔ ' : '') + _vm._s(item))])])]), _vm._v(" \n                          ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_color')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('autocompleteObject', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "suggestions": _vm.colorsByCategory,
      "viewId": 'ColorAutoComplete',
      "placeholder": _vm.locale.t('label_a_color'),
      "changeEvery": true
    },
    on: {
      "update:selectedModel": function($event) {
        _vm.model.color = $event
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.model.color != null && _vm.model.color.length > 0) ? _c('div', {
    staticStyle: {
      "color": "whitesmoke"
    },
    on: {
      "click": function($event) {
        return _vm.deleteColorCategory()
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('delete_color_from_history')) + " "), _c('i', {
    staticClass: "ti-trash",
    staticStyle: {
      "color": "red"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "scrollmenu",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "10px"
    }
  }, _vm._l((_vm.ramMemories), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          _vm.model.ramMemory = item
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      staticClass: "chip-unselected"
    }, [_vm._v(" " + _vm._s(item) + " ")])])]), _vm._v(" \n                            ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_ram_memory')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.ramMemory),
      expression: "model.ramMemory"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_a_ram_memory'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.model.ramMemory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "ramMemory", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollmenu",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "10px"
    }
  }, _vm._l((_vm.romMemories), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          _vm.model.addInfoMemory = item
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      staticClass: "chip-unselected"
    }, [_vm._v(_vm._s(item))])])]), _vm._v(" \n                            ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_memory')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.addInfoMemory),
      expression: "model.addInfoMemory"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_a_memory'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.model.addInfoMemory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "addInfoMemory", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), (_vm.visibleStock) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_stock')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.stockNumber),
      expression: "model.stockNumber"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_a_stock'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.model.stockNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "stockNumber", $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_purchase_price')) + " €")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.purchasePrice),
      expression: "model.purchasePrice"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_a_purchase_price') + '€',
      "name": "email"
    },
    domProps: {
      "value": (_vm.model.purchasePrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "purchasePrice", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_purchase_price')) + " RSD")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.purchasePriceRsd),
      expression: "model.purchasePriceRsd"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_a_purchase_price') + 'RSD',
      "name": "email"
    },
    domProps: {
      "value": (_vm.model.purchasePriceRsd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "purchasePriceRsd", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_buy_date')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.buyDate),
      expression: "model.buyDate"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "date",
      "placeholder": _vm.locale.t('label_buy_date'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.model.buyDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "buyDate", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), (_vm.showInventory()) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_last_inventory_label')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.lastInventoryTimestamp),
      expression: "model.lastInventoryTimestamp"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "date",
      "placeholder": _vm.locale.t('label_last_inventory_label'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.model.lastInventoryTimestamp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "lastInventoryTimestamp", $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.showInventory()) ? _c('div', [_c('div', {
    staticClass: "new-button-approve",
    on: {
      "click": function($event) {
        return _vm.changeArticleInventory()
      }
    }
  }, [_c('b', [_c('i', {
    staticClass: "ti-arrow-up"
  }), _vm._v(_vm._s(_vm.locale.t('label_last_inventory_update_label')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_desc')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.shortDescription),
      expression: "model.shortDescription"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_a_desc'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.model.shortDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "shortDescription", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_comment')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.comment),
      expression: "model.comment"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_a_comment'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.model.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "comment", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.onService),
      expression: "model.onService"
    }],
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "onService",
      "type": "checkbox",
      "name": "key",
      "value": "key"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.onService) ? _vm._i(_vm.model.onService, "key") > -1 : (_vm.model.onService)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.onService,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "key",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "onService", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "onService", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "onService", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white",
      "font-size": "14px"
    },
    attrs: {
      "for": "onService"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_article_service')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.sentByPost),
      expression: "model.sentByPost"
    }],
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "sentByPost",
      "type": "checkbox",
      "name": "key",
      "value": "key"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.sentByPost) ? _vm._i(_vm.model.sentByPost, "key") > -1 : (_vm.model.sentByPost)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.sentByPost,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "key",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "sentByPost", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "sentByPost", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "sentByPost", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white",
      "font-size": "14px"
    },
    attrs: {
      "for": "sentByPost"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_article_sent_by_post')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.isNewArticle),
      expression: "model.isNewArticle"
    }],
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "isNewArticle",
      "type": "checkbox",
      "name": "key",
      "value": "key"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.isNewArticle) ? _vm._i(_vm.model.isNewArticle, "key") > -1 : (_vm.model.isNewArticle)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.isNewArticle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "key",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "isNewArticle", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "isNewArticle", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "isNewArticle", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white",
      "font-size": "14px"
    },
    attrs: {
      "for": "isNewArticle"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_article_is_new')))])]), _vm._v(" "), (_vm.idToEdit == null) ? _c('div', {
    staticClass: "scrollmenu",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "5px"
    }
  }, _vm._l((_vm.regularTypes), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          _vm.regularType = item.id;
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClassRegularType(item)
    }, [_vm._v(_vm._s(_vm.isSelectedRegularType(item) ? '✔ ' : '') + _vm._s(item.label))])])]), _vm._v(" \n                          ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.addArticle
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_save')) + "\n                  ")])])])])], 2)])])])]), _vm._v(" "), _c('choose-imei-after-picture', {
    attrs: {
      "show": _vm.showChooseImeiDialog,
      "options": _vm.showChooseImeiOptions
    }
  }), _vm._v(" "), _c('crop-image-modal', {
    attrs: {
      "show": _vm.showCropImageDialog,
      "file": _vm.fileToCrop
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-panel-brand"
  }, [_c('span', {
    staticClass: "kp-panel-logo-wrap"
  }, [_c('img', {
    staticClass: "kp-panel-logo",
    attrs: {
      "src": require("../../../assets/img/icons/kp.png"),
      "alt": "KP"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-ring"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-ring"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-color-primary"
  }, [_c('i', {
    staticClass: "ti-camera"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-list"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-list"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-paint-bucket"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-menu"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-menu"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-comment"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06447a17!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Article/Add/AddArticle.vue
// module id = 719
// module chunks = 0